module.exports = __webpack_public_path__ + "static/media/dataAnalytics.f3fea826.png";